import React, { useEffect, useState } from 'react';
import API_ENDPOINTS from '../../config/api';
import Kysely, { EMPTY_ANSWERS } from './Kysely';

/**
 * KyselyTask — the Kysely's container: loads the items and this person's
 * state, holds the draft, posts once. Everything drawn is in Kysely, which
 * is what Storybook shows; this file is wiring.
 */
export default function KyselyTask({ instanceId, onChange = null }) {
  const [state, setState] = useState({ loading: true, error: null, data: null });
  const [answers, setAnswers] = useState(EMPTY_ANSWERS);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_ENDPOINTS.ME_KYSELY()}?instanceId=${encodeURIComponent(instanceId)}`, { credentials: 'include', headers: { Accept: 'application/json' } })
      .then(async (r) => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.error || `HTTP ${r.status}`); return d; })
      .then((d) => { if (!cancelled) setState({ loading: false, error: null, data: d }); })
      .catch((err) => { if (!cancelled) setState({ loading: false, error: err.message, data: null }); });
    return () => { cancelled = true; };
  }, [instanceId]);

  const submit = async () => {
    setBusy(true); setError(null);
    try {
      const r = await fetch(API_ENDPOINTS.ME_KYSELY(), {
        method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ instanceId, answers }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || `HTTP ${r.status}`);
      setState({ loading: false, error: null, data: d });
      onChange?.(d);
    } catch (err) { setError(err.message); } finally { setBusy(false); }
  };

  if (state.error) return <Kysely items={null} error={state.error} />;
  const d = state.data;
  return (
    <Kysely items={d?.items || null} answers={answers} onChange={setAnswers} onSubmit={submit}
      submitted={!!d?.submitted} own={d?.own || null} spread={d?.spread || null} submittedAt={d?.own?.submittedAt || null}
      busy={busy} error={error} />
  );
}
